export default (() => {
  document.querySelectorAll('.js-remote').forEach(function (dom) {
    let url = dom.href || dom.dataset.url
    let method = dom.dataset.method || 'GET'
    let params = JSON.parse(dom.dataset.params || '{}')
    dom.addEventListener('click', function (e) {
      e.preventDefault()
      if (dom.dataset.confirm) {
        if (!confirm(dom.dataset.confirm)) {
          return false
        }
      }
      fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
      })
        .then(function (res) {
          // trigger event 'odims:remote:success'
          dom.dispatchEvent(
            new CustomEvent('odims:remote:success', {
              detail: res,
            })
          )
        })
        .catch(function (error) {
          // trigger event 'odims:remote:error'
          dom.dispatchEvent(
            new CustomEvent('odims:remote:error', {
              detail: error,
            })
          )
        })
      return false
    })
  })
})()
